"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitchBotChannelActionType = exports.TwitchStreamOnlineType = exports.TwitchStreamEventType = void 0;
exports.isStreamOnlineEvent = isStreamOnlineEvent;
exports.isChannelUpdateEvent = isChannelUpdateEvent;
exports.isStreamOfflineEvent = isStreamOfflineEvent;
var TwitchStreamEventType;
(function (TwitchStreamEventType) {
    TwitchStreamEventType["STREAM_ONLINE"] = "stream.online";
    TwitchStreamEventType["CHANNEL_UPDATE"] = "channel.update";
    TwitchStreamEventType["STREAM_OFFLINE"] = "stream.offline";
})(TwitchStreamEventType || (exports.TwitchStreamEventType = TwitchStreamEventType = {}));
var TwitchStreamOnlineType;
(function (TwitchStreamOnlineType) {
    TwitchStreamOnlineType["LIVE"] = "live";
    TwitchStreamOnlineType["PLAYLIST"] = "playlist";
    TwitchStreamOnlineType["WATCH_PARTY"] = "watch_party";
    TwitchStreamOnlineType["PREMIERE"] = "premiere";
    TwitchStreamOnlineType["RERUN"] = "rerun";
})(TwitchStreamOnlineType || (exports.TwitchStreamOnlineType = TwitchStreamOnlineType = {}));
var TwitchBotChannelActionType;
(function (TwitchBotChannelActionType) {
    TwitchBotChannelActionType["JOIN"] = "join";
    TwitchBotChannelActionType["LEAVE"] = "leave";
    TwitchBotChannelActionType["CONFIG_UPDATED"] = "configUpdated";
})(TwitchBotChannelActionType || (exports.TwitchBotChannelActionType = TwitchBotChannelActionType = {}));
// Type guard functions
function isStreamOnlineEvent(event) {
    return typeof event === "object" && event !== null && "started_at" in event;
}
function isChannelUpdateEvent(event) {
    return (typeof event === "object" &&
        event !== null &&
        "title" in event &&
        "category_name" in event);
}
function isStreamOfflineEvent(event) {
    return (typeof event === "object" &&
        event !== null &&
        "broadcaster_user_id" in event &&
        !("started_at" in event) &&
        !("title" in event));
}
//# sourceMappingURL=index.js.map